/* eslint-disable react/prop-types */
import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Row, Col, Card, Table, Button, Modal, Avatar, Tag } from 'antd';
import moment from 'moment';
import { AuditOutlined } from '@ant-design/icons';
import './style.css';
import CustomSpin from '../CommonSpin';
import { Content } from 'antd/es/layout/layout';
import { useNavigate } from 'react-router-dom';
import { checkupListRequest, healthRecordImageRequest, healthRecordRequest, packageClickedIdRequest, promotionsRequest, selectedCheckupTable } from './Actions';
import { selectCheckupList, selectCheckupSelectedData, selectHealthRecords, selectLoading, selectPackageIdList, selectPackagePromotions } from './Selectors';
import { BodyTextHeadingSmall, BodyTextValue, ButtonText, ModalData, ModalHeading, ModalTittle, TableHeading, TittleHeader } from '../CommonText';
import Click from '../../Images/click.png';

import english from '../../Translations/English.json';
import hindi from '../../Translations/Hindi.json';
import malayalam from '../../Translations/Malayalam.json';

const { Column } = Table;

// To show checkup details
const CheckupDetails = ({ heading, value, span }) => (
    <Col style={{ fontSize: '15px', marginTop: '8px' }} xs={{ span: 0 }} md={{ span }}>
        <span style={{ color: '#828282' }}><ModalData text = {heading} /></span> <span style={{ fontWeight: 'bold' }}><BodyTextValue text = {value} /></span>
    </Col>
);

const MoreDetails = (props) => (
    <div style={{ marginTop: '10px' }}>
        <strong><ModalData text = {props.heading} color = '#333333'  /></strong> <span>{props.value}</span>
    </div>
);

const MyCheckups = () => {
    const [visibleDetails, setVisibleDetails] = useState(false);
    const [visibleHealthTable, setVisibleHealthTable] = useState(false);
    const [packageDetails, setPackageDetails] = useState(false);
    const [visibleHealthDetails, setVisibleHealthDetails] = useState(false);

    const [selectedHealthRecords, setSelectedHelathRecords] = useState();

    const dispatch = useDispatch();
    const navigate = useNavigate();
    // const checkupDetails = useSelector(makeSelectCheckupsDetails());
    // const requesting = useSelector(makeSelectRequesting());
    const healthData = []; // Add logic for healthData if needed

    const checkupDetails = useSelector(selectCheckupSelectedData);
    const CheckupList = useSelector(selectCheckupList);
    const requesting = useSelector(selectLoading);
    const healthList = useSelector(selectHealthRecords);
    const promotions = useSelector(selectPackagePromotions);
    const packageDetailsData = useSelector(selectPackageIdList);    

    const langid = localStorage.getItem('INTL') ? (localStorage.getItem('INTL')) : 'en';
    const langdata = langid && langid == 'en' ? english : langid == 'ma' ? malayalam : langid == 'hin' ? hindi : english;    

    const patientId = sessionStorage.getItem('PATIENT_ID');    
    
    useEffect(() => {
        if (!patientId) {
            Modal.warning({
                title: 'Complete your profile',
                content: 'Please complete your profile details here...',
            });
            navigate('/addprofile');
        }
    },[]);
        
    useEffect(() => {
        dispatch(checkupListRequest());
        dispatch(promotionsRequest());
    }, [dispatch]);

    const key = (selectedRowKeys) => {
        dispatch(selectedCheckupTable(selectedRowKeys));
        setVisibleDetails(true);
    };

    const Healthkey = (selectedRowKeys) => {
        setSelectedHelathRecords(selectedRowKeys);
        setVisibleDetails(false);
        setVisibleHealthDetails(true);
    };

    const handleCheckupDetailsOk = () => {
        setVisibleDetails(false);
        setVisibleHealthTable(false);
    };

    const handleCheckupDetailsCancel = () => {
        setVisibleDetails(false);
        setVisibleHealthTable(false);
    };

    const handleViewHealthRecords = () => {
        dispatch(healthRecordRequest(checkupDetails && checkupDetails.checkupid));
        setVisibleDetails(false);
        setVisibleHealthTable(true);
    };

    const handleDetailsCancel = () => {
        setPackageDetails(false);
        setVisibleHealthDetails(false);
    };

    const pageSizeChangeCheckups = () => {
        // dispatch({ type: PROMTION_PACKAGES_GET });
    };

    const moreDetails = () => {
        // props.dispatch({ type: PACKAGE_MODAL_DETAILS_GET });
        setPackageDetails(true);
    };

    let content = null;
    let footer = null;


    if (checkupDetails !== null && checkupDetails) {
        content = (
            <div>
                <Row>
                    <CheckupDetails heading={`${langdata.CheckupIdC ? langdata.CheckupIdC : 'Checkup Id:' }`} value={checkupDetails && checkupDetails.checkupid} span={14} />
                    <CheckupDetails heading={`${langdata.PatientNameC ? langdata.PatientNameC : 'Patient Name:' }`} value={checkupDetails && checkupDetails.patientName} span={10} />
                    <CheckupDetails heading={`${langdata.PackageNameC ? langdata.PackageNameC : 'Package Name:' }`} value={checkupDetails && checkupDetails.packageName} span={14} />
                    <CheckupDetails heading={`${langdata.DateC ? langdata.DateC : 'Date:' }`} value={checkupDetails && checkupDetails.date} span={10} />
                    <CheckupDetails heading={`${langdata.OrganisationNameC ? langdata.OrganisationNameC : 'Organisation Name:' }`} value={checkupDetails && checkupDetails.orgname} span={14} />
                    <CheckupDetails heading={`${langdata.OrginalPriceC ? langdata.OrginalPriceC : 'Orginal Price:' }`} value={`₹ ${checkupDetails && checkupDetails.originalPrice}`} span={10} />
                    <CheckupDetails heading={`${langdata.DiscountPC ? langdata.DiscountPC : 'Discount(%):' }`} value={`${checkupDetails && checkupDetails.discountper} %`} span={14} />
                    <CheckupDetails heading={`${langdata.DiscountC ? langdata.DiscountC : 'Discount:' }`} value={`₹ ${checkupDetails && checkupDetails.discount}`} span={10} />
                    <CheckupDetails heading={`${langdata.StatusC ? langdata.StatusC : 'Status:' }`} value={checkupDetails && checkupDetails.status} span={14} />
                    <CheckupDetails heading={`${langdata.GrandTotalC ? langdata.GrandTotalC : 'Grand Total:' }`} value={checkupDetails && `₹ ${checkupDetails.grandTotal ? checkupDetails.grandTotal : 0}`} span={10} />
                    {checkupDetails && checkupDetails.isSampleCollectedAtHome && (
                        <CheckupDetails heading={`${langdata.SampleCollectionFeeC ? langdata.SampleCollectionFeeC : 'Sample Collection Fee:' }`} value={checkupDetails && checkupDetails.pickupCost} span={14} />
                    )}
                    <CheckupDetails heading={`${langdata.TimeC ? langdata.TimeC : 'Time:' }`} value={checkupDetails && moment(checkupDetails.time, 'hh:mm A').format('hh:mm A')} span={10} />
                    {checkupDetails && checkupDetails.description && (
                        <CheckupDetails heading={`${langdata.PackageDescriptionC ? langdata.PackageDescriptionC : 'Package Description:' }`} value={checkupDetails && checkupDetails.description} span={24} />
                    )}
                </Row>
            </div>
        );

        footer = [
            <Button key="submit" onClick={handleCheckupDetailsOk}>
                {`${langdata.Cancel ? langdata.Cancel :  'Cancel' }`}
            </Button>,
            checkupDetails && checkupDetails.status === 'Completed' && (
                <Button type="primary" onClick={handleViewHealthRecords}>
                    {`${langdata.ViewHealthRecords ? langdata.ViewHealthRecords : 'View Health Records' }`}
                </Button>
            ),
            checkupDetails && checkupDetails.status === 'Booking' && (
                <Button
                    type="primary"
                    onClick={() => {
                        window.open(checkupDetails.gatewayUrl);
                    }}
                >
                    {`${langdata.MakePayment ? langdata.MakePayment : 'Make Payment' }`}
                </Button>
            ),
        ];
    }

    let promotionDetails = null;
    if(promotions && promotions !== null ){
        promotionDetails = promotions && promotions.map((item) => (
            <div
                key = {item.id}
                style={{
                    background: '#fff',
                    borderRadius: '4px',
                    boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.04)',
                    marginBottom: '20px',
                    marginTop: '5px',
                }}
            >
                <div style={{ fontSize: '20px', fontWeight: 'bold', paddingTop: '25px' }}>
                    <ModalHeading text = {item.packageName} />
                </div>
                {item.isDiscounted === true ? (
                    <div style={{ marginTop: '25px' }}>
                        <span style={{ fontSize: '16px', textDecoration: 'line-through' }}>
                ₹{item.originalPrice}
                        </span>{' '}
                        <span style={{ fontSize: '20px', color: '#185177', fontWeight: 'bolder' }}>
                ₹{item.discountPrice}
                        </span>
                    </div>
                ) : (
                    <div style={{ marginTop: '25px' }}>
                        <span style={{ fontSize: '20px', color: '#185177', fontWeight: 'bolder' }}>
                            {' '}
                  ₹ {item.originalPrice}
                        </span>
                    </div>
                )}
                {item.isDiscounted === true ? (
                    <div>
                        <span><ModalData text = {`${langdata.Discount ? langdata.Discount : 'Discount' }`} /> </span>
                        <span>{item.discountPercentage}%</span>
                    </div>
                ) : null}

                <div style={{ marginTop: '25px' }}>
                    <Button
                        style={{
                            backgroundColor: '#f66b04',
                            color: '#fff',
                            fontWeight: 'bold',
                            borderRadius: '16px',
                            width: '150px',
                            height: '35px',
                            borderColor: '#f66b04',
                        }}
                        onClick={() => {
                            navigate(('/bookcheckup'),{state : {data : item, promotion : true }});
                        }}
                    >
                        <ButtonText text = {`${langdata.BookNow ? langdata.BookNow : 'Book Now' }`} />
                    </Button>{' '}
                </div>
                <div style={{ marginTop: '25px' }}>{item.tests[0]}</div>
                <div style={{ paddingBottom: '20px', paddingTop: '10px' }}>
                    <a
                        onClickCapture={() => {
                            dispatch(packageClickedIdRequest(item));
                        }}
                        onClick={moreDetails}    
                    >
                        {`${langdata.Moredetails ? langdata.Moredetails : 'More details' }`}
                    </a>
                </div>
            </div>
        ));
    }

    let packageModalContent = null;
    if (packageDetailsData !== null) {
        const tests = packageDetailsData && packageDetailsData.tests.map((item) => (
            <div key = {item.id} style={{ marginBottom: '5px' }}>
                <Tag color="blue">{item}</Tag>
            </div>
        ));        

        packageModalContent = (
            <div>
                <MoreDetails heading={`${langdata.PackageNameC ? langdata.PackageNameC : 'Package Name:' }`} value={packageDetailsData && packageDetailsData.packageName} />
                <MoreDetails
                    heading={`${langdata.OrganisationNameC ? langdata.OrganisationNameC : 'Organisation Name:' }`}
                    value={packageDetailsData && packageDetailsData.name}
                />
                <MoreDetails
                    heading={`${langdata.OrginalPriceC ? langdata.OrginalPriceC : 'Orginalprice:' }`}
                    value={`₹${packageDetailsData && packageDetailsData.originalPrice}`}
                />
                {packageDetailsData && packageDetailsData.isDiscounted === true ? (
                    <MoreDetails
                        heading={`${langdata.DiscountPriceC ? langdata.DiscountPriceC : 'Discount price:'}`}
                        value={`₹${packageDetailsData&& packageDetailsData.discountPrice}`}
                    />
                ) : null}
                <div style={{ marginTop: '10px' }}>
                    <strong><ModalData text = {`${langdata.TestsC ? langdata.TestsC : 'Tests:' }`}  color = '#333333'  /> </strong><span>{tests}</span>
                </div>
            </div>
        );
    }

    let data = [];
    if (CheckupList) {
        CheckupList && CheckupList.data && CheckupList.data.map(item => {            
            data.push({
                id: item.id,
                orgname: item.organisation.name,
                checkupname: item.package.name,
                checkupid: item.id,
                patientName: `${item.patient.firstName} ${item.patient.lastName}`,
                date: moment(item.date).format('DD-MM-YYYY'),
                status: item.status,
                packageName: item.package.name,
                originalPrice: item.package.originalPrice,
                discountper: item.package.discountPercentage,
                discount: item.package.discount,
                grandTotal: item.checkuppayment && item.checkuppayment.amount,
                isSampleCollectedAtHome: item.isSampleCollectedAtHome,
                pickupCost: item.organisation.pickupCost,
                time: item.time,
                description: item.package.description,
                gatewayUrl: item.checkuppayment && item.checkuppayment.gatewayUrl
            });
        });
    }

    if (healthList) {
        healthList && healthList.map((item) => {            
            healthData.push({
                id: item.id,
                patientName: `${item.firstName} ${item.lastName}`,
                healthRecType: item.healthRecType,
                organisationName: item.organisationName,
                fileurl: item.fileurl,
                createdAt : item.createdAt
            });
        });
    }            

    return (
        <Content>
            <div>
                <Row type="flex" justify="center">
                    <Col xs={{ span: 24 }} md={{ span: 24, offset: 0 }}>
                        <Col
                            xs={{ span: 24 }}
                            md={{ span: 24 }}
                            style={{
                                marginTop: '5px',
                                marginBottom: '15px',
                            }}
                        >

                            <Col
                                xs={{ span: 23 }}
                                md={{ span: 23 }}
                                lg={{ span: 23 }}
                                xl={{ span: 23 }}
                                xxl={{ span: 23 }}
                                style={{
                                    marginLeft: '2%',
                                    background: '#fff',
                                    boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.04)',
                                    borderRadius: '4px',
                                }}
                            >
                                <Row>
                                    <Col xs={{ span: 24 }} md={{ span: 16 }} lg={{ span: 10 }} xl={{ span: 10 }} xxl={{ span: 10 }} style={{ textAlign: 'right' }}>
                                        <div
                                            style={{
                                                marginLeft: '1%',
                                                textAlign: 'left',
                                                fontFamily: 'Roboto',
                                                fontSize: '27px',
                                                color: '#1164A6',
                                                padding: '8px',
                                                display: 'flex',
                                            }}
                                        >
                                            <AuditOutlined /> <TittleHeader text = {`${langdata.MyCheckups ? langdata.MyCheckups : 'My Checkups'}`} color='#1164A6'/>
                                        </div>
                                    </Col>
                                    <Col xs={{ span: 24 }} md={{ span: 8 }} lg={{ span: 14 }} xl={{ span: 14 }} xxl={{ span: 14 }} style={{ textAlign: 'right', paddingTop: '12px', paddingBottom: '10px' }}>
                                        <span >
                                            <Button
                                                style={{ margin: '15px' }}
                                                type="primary"
                                                onClick={() => {
                                                    navigate('/allpackages');
                                                }}
                                            >
                                                <ButtonText text = {`${langdata.BookCheckup ? langdata.BookCheckup : 'Book Checkup' }`} />
                                            </Button>
                                        </span>
                                    </Col>
                                </Row>
                            </Col>

                            <Row>
                                <Col
                                    xs={{ span: 23 }}
                                    sm={{ span: 23 }}
                                    md={{ span: 23 }}
                                    lg={{ span:23 }}
                                    xl={{ span: promotions && promotions.length == 0 ? 23 : 18 }}
                                    xxl={{ span: promotions && promotions.length == 0 ? 23 : 18 }}


                                    style={{
                                        margin: '2%',
                                    }}
                                >

                                    <Card >
                                        <Table
                                            className="custom-pagination" 
                                            onRow={(record) => ({
                                                onClick: () => key(record),
                                            })}
                                            dataSource={data}
                                            bordered
                                            scroll={{ x: 900 }}
                                            pagination={{
                                                defaultPageSize: 10,
                                                hideOnSinglePage: true,
                                                defaultCurrent: 1,
                                                onChange: pageSizeChangeCheckups,
                                            }}
                                            // scroll={{ x: '1200' }}
                                        >
                                            <Column title={<TableHeading text = {`${langdata.CheckupID ? langdata.CheckupID : 'Checkup ID' }`} /> } dataIndex="checkupid" key="checkupid" width="80" />
                                            <Column title={<TableHeading text = {`${langdata.PatientName ? langdata.PatientName : 'Patient Name' }`} /> } dataIndex="patientName" key="patientName" width="100" />
                                            <Column title={<TableHeading text = {`${langdata.OrganisationName ? langdata.OrganisationName : 'Organisation Name' }`} /> } dataIndex="orgname" key="orgname" width="100" />
                                            <Column title={<TableHeading text = {`${langdata.CheckupName ? langdata.CheckupName : 'Checkup Name'  }`}/> } dataIndex="checkupname" key="checkupname" width="200" />
                                            <Column title={<TableHeading text = {`${langdata.Date ? langdata.Date : 'Date' }`}/> } dataIndex="date" key="date" width="150" />
                                            <Column title={<TableHeading text = {`${langdata.Status ? langdata.Status : 'Status' }`} /> } dataIndex="status" key="status" width="200" />
                                        </Table>
                                    </Card>
                                </Col>
                                <Col
                                    xs={{ span: promotions && promotions.length == 0 ? 0 : 23 }}
                                    sm={{ span: promotions && promotions.length == 0 ? 0 : 23 }}
                                    md={{ span: promotions && promotions.length == 0 ? 0 : 23 }}
                                    lg={{ span: promotions && promotions.length == 0 ? 0 : 23 }}
                                    xl={{ span: promotions && promotions.length == 0 ? 0 : 4 }}
                                    xxl={{ span: promotions && promotions.length == 0 ? 0 : 4 }}
                                            
                                    style={{
                                        textAlign: 'center',
                                        margin: '2%',
                                    }}
                                >
                                    {promotionDetails}
                                </Col>
                            </Row>
                        </Col>
                    </Col>
                </Row>
                <Modal
                    title={<BodyTextHeadingSmall text = {`${langdata.CheckupDetails ? langdata.CheckupDetails : 'Checkup Details' }`} /> }
                    open={visibleDetails}
                    onCancel={handleCheckupDetailsCancel}
                    onOk={handleCheckupDetailsOk}
                    width="60%"
                    footer={footer}
                >
                    <Row>
                        {content}
                    </Row>
                </Modal>

                <Modal
                    title={<BodyTextHeadingSmall text = {`${langdata.HealthRecords ? langdata.HealthRecords : 'Health Records' }`}/> }
                    open={visibleHealthTable}
                    onCancel={handleCheckupDetailsCancel}
                    onOk={handleCheckupDetailsOk}
                    width="60%"
                    footer={null}
                >
                    <Row style={{ display: 'contents' }}>
                        <Table
                            onRow={(record) => ({
                                onClick: () => Healthkey(record),
                            })}
                            dataSource={healthData}
                            bordered
                            pagination={{
                                defaultPageSize: 10,
                                hideOnSinglePage: true,
                                onChange: pageSizeChangeCheckups,
                                defaultCurrent: 1,
                            }}
                        >
                            <Column title={<TableHeading text = {`${langdata.HealthRecordID ? langdata.HealthRecordID : 'Health Record ID' }`}/> } dataIndex="id" key="id" width="60" />
                            <Column title={<TableHeading text = {`${langdata.PatientName ? langdata.PatientName : 'Patient Name' }`} /> } dataIndex="patientName" key="patientName" width="100" />
                            <Column title={<TableHeading text = {`${langdata.RecordType ? langdata.RecordType : 'Record Type' }`} /> } dataIndex="healthRecType" key="healthRecType" width="80" />
                            <Column title={<TableHeading text = {`${langdata.Createdby ? langdata.Createdby : 'Created by' }1`} /> } dataIndex="organisationName" key="organisationName" width="100" />
                        </Table>
                    </Row>
                </Modal>

                <Modal
                    title={<BodyTextHeadingSmall text = {`${langdata.PackageDetails ? langdata.PackageDetails : 'Package Details' }`} /> }
                    open={packageDetails}
                    onCancel={handleDetailsCancel}
                    onOk={handleDetailsCancel}
                    width="40%"
                    footer={null}
                >
                    <Row>
                        {packageModalContent}
                    </Row>
                </Modal>

                <Modal
                    open={visibleHealthDetails}
                    // onOk={handleOk}
                    onCancel={handleDetailsCancel}
                    width={683}
                    footer={false}
                    style={{ marginTop: '10px' }}
                    className="bg-bgwhite"
                >
                    {/* <Row> */}
                    <Row
                        style={{
                            background: '#1164A6',
                            height: '100px',
                            // width: '683px',
                            marginTop: '-20px',
                            marginRight: '-24px',
                            marginLeft: '-24px',
                            borderRadius: '8px 8px 0px 0px',
                            display: 'flex'
                        }}
                    >
                        <Col span={17} style={{ marginTop: '32px', marginLeft: '20px' }}>
                            <div style={{ color: '#FFFFFF', fontSize: '25px' }}>
                                <ModalTittle text={selectedHealthRecords && selectedHealthRecords.organisationName} color='#ffffff' />
                            </div>
                        </Col>
                        <Col
                            span={6}
                            style={{ marginTop: '42px', color: '#FFFFFF', fontSize: '15px' }}
                        >
                            <div>
                                On: {selectedHealthRecords && moment(selectedHealthRecords.createdAt).format('DD')} - {selectedHealthRecords && moment(selectedHealthRecords.createdAt).format('MMM')} -{' '}
                                {selectedHealthRecords && moment(selectedHealthRecords.createdAt).format('YYYY')}
                            </div>
                        </Col>
                    </Row>
                    {/* </Row> */}
                    <Row>
                        <Col span={24}>
                            <Row>
                                <Col xs={{ span: 24 }} lg={{ span: 16 }} style={{ marginTop: '2%', marginBottom: '10%' }}>
                                    <div style={{ color: '#4F4F4F', fontFamily: 'Roboto', fontSize: '21px' }}>
                                        <ModalHeading text={`${langdata.RecordType ? langdata.RecordType : 'Record Type'}`} />
                                    </div>
                                    <div>{selectedHealthRecords && selectedHealthRecords.healthRecType}</div>
                                </Col>
                                <Col
                                    xs={{ offset: 1, span: 24 }}
                                    lg={{ span: 8, offset: 15 }}
                                    style={{ marginTop: '-12%', textAlign: 'right' }}
                                >
                                    {selectedHealthRecords && selectedHealthRecords.fileurl !== null ? (
                                        <Card
                                            style={{ paddingLeft: '10%', cursor: 'pointer' }}
                                            bordered={false}
                                            onClick={() => {
                                                // dispatch({ type: RECORD_IMAGE_OPEN, payload: item.fileurl });
                                                dispatch(healthRecordImageRequest(selectedHealthRecords && selectedHealthRecords.fileurl));
                                            }}
                                        >
                                            <Avatar style={{ cursor: 'pointer' }} shape="square" size={87} icon="user" src={Click} />
                                        </Card>
                                    ) : (
                                        // <div>{body}</div>
                                        <></>
                                    )}
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                    {/* <Row>
                                        <Col xs={{ span: 0 }} lg={{ span: 0 }}>
                                            <Button className="ant_btt" style={{ float: 'right', marginTop: '25px', marginRight: '10px' }}>
                                                Send Email
                                            </Button>
                                        </Col>
                                    </Row> */}
                </Modal>

                <CustomSpin spinning={requesting} />
            </div>
        </Content>
    );
};


export default MyCheckups;
